import { SiInstagram, SiTiktok, SiYoutube } from 'react-icons/si';
import { CampaignCategoryBadges } from '@/components/campaigns/CampaignCategoryBadges';
import { visibleCampaignCategories } from '@/lib/campaigns/campaignCategories';

/**
 * Categories and platforms drawn over the bottom of a campaign banner, on a
 * dark gradient with white-on-black chips so they stay readable on any image.
 * Render it as a CampaignBanner child: it disappears with a missing banner.
 */
export function CampaignBannerInfo({ categories, platforms = [], platformsTestId }: {
  categories?: ReadonlyArray<string | null | undefined> | null;
  platforms?: ReadonlyArray<string>;
  platformsTestId?: string;
}) {
  const hasCategories = visibleCampaignCategories(categories).length > 0;
  if (!hasCategories && platforms.length === 0) return null;

  return (
    <div className="pointer-events-none absolute inset-x-0 bottom-0 flex items-end justify-between gap-2 bg-gradient-to-t from-black/80 via-black/40 to-transparent px-3 pb-2 pt-8">
      <CampaignCategoryBadges categories={categories} variant="onImage" compact className="min-w-0" />
      {platforms.length > 0 && (
        <span
          data-testid={platformsTestId}
          className="ml-auto inline-flex flex-shrink-0 items-center gap-1.5 rounded-full border border-white/20 bg-black/60 px-2 py-1 text-white backdrop-blur-sm"
        >
          {platforms.includes('tiktok') && <SiTiktok className="h-3 w-3" aria-label="TikTok" />}
          {platforms.includes('instagram') && <SiInstagram className="h-3 w-3" aria-label="Instagram" />}
          {platforms.includes('youtube') && <SiYoutube className="h-3 w-3" aria-label="YouTube" />}
        </span>
      )}
    </div>
  );
}
